const API_BASE = process.env.REACT_APP_API_BASE;
const TOKEN = process.env.REACT_APP_TOKEN;

const rankRequestService = {
  // Get all rank requests (admin only)
  getAllRequests: async () => {
    try {
      const response = await fetch(`${API_BASE}/rankRequest/get`, {
        method: 'GET',
        headers: {
          'Authorization': `Basic ${TOKEN}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.data ? result.data : (Array.isArray(result) ? result : []);
    } catch (error) {
      console.error('Error fetching rank requests:', error);
      throw error;
    }
  },

  // Create a new rank request
  createRequest: async (requestData) => {
    try {
      const response = await fetch(`${API_BASE}/rankRequest/post`, {
        method: 'POST',
        headers: {
          'Authorization': `Basic ${TOKEN}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating rank request:', error);
      throw error;
    }
  },

  // Update rank request status (approve/reject)
  updateRequestStatus: async (requestId, status, adminNotes = '') => {
    try {
      const response = await fetch(`${API_BASE}/rankRequest/put?id=${requestId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Basic ${TOKEN}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          status,
          adminNotes,
          reviewedDate: new Date().toISOString()
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating rank request:', error);
      throw error;
    }
  },

  // Delete rank request
  deleteRequest: async (requestId) => {
    try {
      const response = await fetch(`${API_BASE}/rankRequest/delete?id=${requestId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Basic ${TOKEN}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting rank request:', error);
      throw error;
    }
  },

  // Get rank requests for a specific user
  getUserRequests: async (userId) => {
    try {
      const response = await fetch(`${API_BASE}/rankRequest/get?userId=${userId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Basic ${TOKEN}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching user rank requests:', error);
      throw error;
    }
  }
};

export default rankRequestService;
